import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { fetchSurgeryReport } from "app/services/dashboard/surgeryTypesService";
import { BASE_URL } from "static/constants";

export const surgeryProcedureApi = createApi({
  reducerPath: "surgerProcedureApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    generateReport: builder.mutation({
      queryFn: (payload) => {
        return { data: fetchSurgeryReport(payload) };
      },
    }),
  }),
});

export const { useGenerateReportMutation } = surgeryProcedureApi;
